module.exports = __webpack_public_path__ + "img/background039.183f1585.jpg";